// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"f6442f3c","76":"14485a9f","108":"9ef8653e","198":"a4f0a718","210":"9acb48c0","244":"d8c76a4b","535":"61dc1f76","703":"df193ff6","808":"dc4eb1b3","896":"514d7508"}[chunkId] + ".chunk.js";
};